const Header = (()=>{
    
    const HeaderConfig = ()=>{
        const headerBtn = document.querySelector('.headerHamburger');
        headerBtn.addEventListener('click', ()=>{
            const header = headerBtn.closest('header');
            const headerHeight = document.querySelector('.headerMenu');
            headerBtn.classList.toggle('active');
            header?.classList.toggle('active');
            if(header.classList.contains('active')){
                headerHeight.style.height = `${headerHeight.scrollHeight}px`;
            }else{
                headerHeight.style.height = `0`;                
            }
        });
    }

    // const ScrollDetection = ()=>{
    //     const header = document.querySelector('header');
    //     let lastScroll = 0;
        
    //     window.addEventListener('scroll', ()=>{
    //         const currentScroll = window.pageYOffset || document.documentElement.scrollTop;
            
    //         if(currentScroll > 300){
    //             header?.classList.add('scrolled');
    //         } else {
    //             header?.classList.remove('scrolled');
    //         }
            
    //         lastScroll = currentScroll;
    //     });
    // }

    const OpenModal = () => {
        // Búsqueda Modal
        const searchModal = document.getElementById('searchModal');
        const openSearchBtn = document.getElementById('openSearchModal');
        const closeSearchBtn = document.getElementById('closeSearchModal');
        const searchInput = document.getElementById('searchModalInput');
        const searchOverlay = searchModal?.querySelector('.searchModal__overlay');

        // Abrir modal
        openSearchBtn?.addEventListener('click', () => {
            searchModal.classList.add('is-active');
            document.body.classList.add('search-modal-open');
            // Enfocar el input después de la animación
            setTimeout(() => {
                searchInput?.focus();
            }, 300);
        });

        // Cerrar modal
        const closeSearch = () => {
            searchModal?.classList.remove('is-active');
            document.body.classList.remove('search-modal-open');
            searchInput.value = '';
        };

        closeSearchBtn?.addEventListener('click', closeSearch);
        searchOverlay?.addEventListener('click', closeSearch);

        // Cerrar con tecla ESC
        document.addEventListener('keydown', (e) => {
            if (e.key === 'Escape' && searchModal?.classList.contains('is-active')) {
                closeSearch();
            }
        });

        // Prevenir cierre al hacer click dentro del contenido
        searchModal?.querySelector('.searchModal__content')?.addEventListener('click', (e) => {
            e.stopPropagation();
        });
    
    }

    const VideoHeightHero = () => {
        const video = document.querySelector('#bg-video');
        const hero = document.querySelector('#home-hero');

        video.style.minHeight = `calc(100svh - ${hero.scrollHeight}px)`;
        
        window.addEventListener('resize', ()=>{
            video.style.minHeight = `calc(100svh - ${hero.scrollHeight}px)`;
        });
    }


    return {
        childsHeader : function(){
            try { HeaderConfig(); } catch (error) { }
            try { VideoHeightHero(); } catch (error) { }
            try { OpenModal(); } catch (error) { }
        }
    }

})();


const getHeaderHandlers = ()=>{
    Header.childsHeader();
}

export { getHeaderHandlers }